import { render, staticRenderFns } from "./SubjectOverview.vue?vue&type=template&id=3b611ab7&scoped=true&"
import script from "./SubjectOverview.vue?vue&type=script&lang=js&"
export * from "./SubjectOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b611ab7",
  null
  
)

export default component.exports